import { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import { Box, Typography as MIUTypography, CircularProgress } from '@mui/material'
import WifiOffIcon from '@mui/icons-material/WifiOff'
import treeBackgound from '../../assets/images/bg-001.png'
import { useTheme } from '@mui/material/styles'

const Typography = styled(MIUTypography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 500,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.1rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.2rem',
  },
}))

const CheckConnection = () => {
  const [online, setOnline] = useState(navigator.onLine)
  const theme = useTheme()

  const loadingTextStyle = {
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
    fontSize: '1.8rem',
    color: 'white',
    textShadow: '0 0 10px #4e6a5b, 0 0 10px #E0DED1',
    pt: 4,
  }

  useEffect(() => {
    const handleOnline = () => setOnline(true)
    const handleOffline = () => setOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (online) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'rgba(255,255,255,0.95)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'start',
        textAlign: 'center',
        backgroundImage: `url(${treeBackgound})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        p: 2,
      }}>
      <Box
        sx={{
          position: 'relative',
          width: 100,
          height: 100,
          mt: {
            xs: '5vh', // móviles
            sm: '10vh', // tablets
            md: '15vh', // escritorio
          },
        }}>
        <WifiOffIcon
          sx={{
            fontSize: 60,
            color: 'error.main',
            position: 'absolute',
            top: 20,
            left: 20,
          }}
        />
      </Box>
      <Typography
        variant="h4"
        sx={{
          mt: {
            xs: '2vh', // móviles
            sm: '2vh', // tablets
            md: '5vh', // escritorio
          },
          fontWeight: 700,
          bgcolor: '#ffffff9f',
          p: 1,
        }}>
        Sin conexión a internet
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: 'text.primary',
          maxWidth: {
            xs: '90%',
            sm: '80%',
            md: '60%',
            lg: '40%',
          },
          mt: {
            xs: '5vh', // móviles
            sm: '5vh', // tablets
            md: '10vh', // escritorio
          },
          textShadow: '0 0 10px #4e6a5b, 0 0 10px #E0DED1',
          bgcolor: '#ffffff9f',
          p: 1,
        }}>
        Por favor, verifica tu red. La aplicación se reanudará automáticamente cuando
        vuelvas a estar en línea.
      </Typography>
      <Typography
        sx={{
          ...loadingTextStyle,
          fontSize: '1.3rem',
          bgcolor: '#00000052',
          p: 1,
        }}>
        Esperando conexión...{' '}
        <Box component="span">
          <CircularProgress
            size={15}
            sx={theme => ({ color: theme.palette.background.default })}
            thickness={38}
          />
        </Box>
      </Typography>
    </Box>
  )
}

export default CheckConnection
